import * as io from "io-ts";
import { useCallback, useEffect, useMemo } from "react";
import createGlobalState from "@ui/lib/createGlobalState";
import type { BlockPlotModelT } from "../../../../../../schema/block/plot";

export const useLinkedPlotList = createGlobalState({
  key: "dashboardLinkedPlotList",
  storage: "local",
  type: io.array(io.string),
  defaultValue: [] as string[],
  scoped: true,
});

export const usePlotLink = (block: BlockPlotModelT | undefined) => {
  const [linkedPlotList, setLinkedPlotList] = useLinkedPlotList({
    scope: block?.dashboardId || "",
  });
  const isLinked = useMemo(
    () => (block?.id ? linkedPlotList.includes(block.id) : false),
    [block?.id, linkedPlotList],
  );

  const setLink = useCallback(
    (link: boolean) => {
      if (link) {
        setLinkedPlotList(
          list => Array.from(new Set([...list, block?.id])).filter(Boolean) as string[],
        );
      } else {
        setLinkedPlotList(list => list.filter(id => id !== block?.id));
      }
    },
    [block?.id, setLinkedPlotList],
  );

  useEffect(() => {
    if (block?.config.options?.sync) {
      setLinkedPlotList(
        list => Array.from(new Set([...list, block?.id])).filter(Boolean) as string[],
      );
    }
  }, [block?.config.options?.sync, block?.id, setLinkedPlotList]);

  return { isLinked, setLink };
};
